import PurchasePriceEditor from './PurchasePriceEditor';

export default PurchasePriceEditor;
